module.exports = __webpack_public_path__ + "media/images/ui__textArrowDownLight-28f9c805bb0d6ea1679ddeb4d4f4295f.png";